import { useState } from "react";
import { usePlay, Panel, Label, Felt } from "./usePlay";
import { Hand } from "./PlayingCard";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

const SIDES = {
  baccarat: { path: "/games/baccarat", a: ["player", "Oyunçu", "x2", "bg-sky-700"], b: ["banker", "Bankir", "x1.95", "bg-red-700"], t: ["tie", "Heç-heçə", "x9", "bg-emerald-700"] },
  dragontiger: { path: "/games/dragontiger", a: ["dragon", "Əjdaha", "x2", "bg-red-700"], b: ["tiger", "Pələng", "x2", "bg-amber-600"], t: ["tie", "Heç-heçə", "x12", "bg-emerald-700"] },
};
const NAME = { player: "Oyunçu", banker: "Bankir", dragon: "Əjdaha", tiger: "Pələng", tie: "Heç-heçə" };

export const DuelGame = ({ mode, kind }) => {
  const cfg = SIDES[kind];
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [side, setSide] = useState(cfg.a[0]);
  const [res, setRes] = useState(null);
  const go = async () => {
    setRes(null);
    const d = await play(cfg.path, { bet, side });
    if (!d) return;
    sfx.flip();
    setRes(d);
    setTimeout(() => finish(d), 900);
  };
  const left = res ? (kind === "baccarat" ? res.player : [res.dragon]) : [];
  const right = res ? (kind === "baccarat" ? res.banker : [res.tiger]) : [];
  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid={`${kind}-game`}>
      <Panel className="order-2 lg:order-1">
        <div><Label>Mərc</Label><BetControl value={bet} onChange={setBet} disabled={busy} testid={`${kind}-bet`} /></div>
        <div><Label>Kimə mərc?</Label>
          <div className="grid grid-cols-3 gap-2">
            {[cfg.a, cfg.t, cfg.b].map(([v, l, m, bg]) => (
              <button key={v} disabled={busy} onClick={() => setSide(v)} className={`rounded-xl py-3 font-display font-bold flex flex-col items-center transition-all ${side === v ? `${bg} ring-2 ring-[#FFD700] scale-[1.03]` : "bg-white/5 hover:bg-white/10"}`} data-testid={`${kind}-side-${v}`}>
                <span className="text-sm">{l}</span><span className="text-xs opacity-80">{m}</span>
              </button>
            ))}
          </div>
        </div>
        <button disabled={busy} onClick={go} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid={`${kind}-deal-btn`}>Payla · {fmtAZN(bet)}</button>
        <p className="text-xs text-zinc-500">{kind === "baccarat" ? "Rəsmi üçüncü kart qaydaları. Heç-heçədə Oyunçu/Bankir mərci qaytarılır." : "Yüksək kart qazanır (A ən aşağı). Heç-heçədə Əjdaha/Pələng mərcinin yarısı qaytarılır."}</p>
      </Panel>
      <Felt className="flex flex-col justify-center gap-8" testid={`${kind}-table`}>
        <div className="grid grid-cols-2 gap-4 items-start">
          <Hand cards={left} label={NAME[cfg.a[0]]} total={res ? (kind === "baccarat" ? res.player_total : null) : null} hidden={res ? 0 : kind === "baccarat" ? 2 : 1} testid={`${kind}-left`} />
          <Hand cards={right} label={NAME[cfg.b[0]]} total={res ? (kind === "baccarat" ? res.banker_total : null) : null} hidden={res ? 0 : kind === "baccarat" ? 2 : 1} testid={`${kind}-right`} />
        </div>
        <p className={`text-center font-display font-black text-2xl h-9 ${res ? (res.won ? "text-emerald-300" : res.win > 0 ? "text-sky-300" : "text-red-300") : ""}`} data-testid={`${kind}-result`}>
          {res ? `${NAME[res.outcome]} qazandı · ${res.won ? `+${fmtAZN(res.win)}` : res.win > 0 ? `Qaytarıldı ${fmtAZN(res.win)}` : "Uduzdunuz"}` : ""}
        </p>
      </Felt>
    </div>
  );
};

export const BaccaratGame = (p) => <DuelGame {...p} kind="baccarat" />;
export const DragonTigerGame = (p) => <DuelGame {...p} kind="dragontiger" />;
